<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Winstberekening
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De winst van een eenmanszaak kan op verschillende manieren worden berekend. Twee veelgebruikte methoden
                zijn:
                <div class="space10"></div>

                <b>1. Winstberekening op basis van opbrengsten en kosten</b><br/>
                Dit is de meest directe en gebruikelijke methode om de winst te berekenen. Hierbij wordt de winst als
                volgt bepaald:
                <div class="space10"></div>

                Winst = Opbrengsten - Kosten**
                <div class="space10"></div>
                <i>
                    Opbrengsten: Dit zijn alle inkomsten die de eenmanszaak heeft gegenereerd in een bepaalde periode,
                    bijvoorbeeld uit de verkoop van producten of diensten.<br/>
                    Kosten: Dit zijn alle uitgaven die gemaakt zijn om de onderneming draaiende te houden, zoals
                    inkoopkosten, huur, salarissen, marketingkosten, enz.
                </i>
                <div class="space10"></div>

                Bijvoorbeeld, als een eenmanszaak in een jaar € 100.000 aan omzet heeft gegenereerd en € 70.000 aan
                kosten heeft gemaakt, dan is de winst:
                <div class="space10"></div>
                Winst = €100.000 - €70.000 = €30.000
                <div class="space10"></div>

                <b>2. Winstberekening op basis van vermogensvergelijking</b><br/>
                Een alternatieve manier om de winst te berekenen is door een vermogensvergelijking te maken. Hierbij
                kijk je naar de verandering in het eigen vermogen van de onderneming over een bepaalde periode.
                <div class="space10"></div>
                Winst = Eigen vermogen einde jaar - Eigen vermogen begin jaar + Privé-opnamen - Privé-stortingen
                <div class="space10"></div>

                <i>Eigen vermogen begin van het jaar: Dit is het eigen vermogen dat aan het begin van het jaar
                    beschikbaar was.<br/>
                    Eigen vermogen eind van het jaar: Dit is het eigen vermogen aan het einde van het jaar.<br/>
                    Privé-opnamen: Dit zijn bedragen die de eigenaar in de loop van het jaar uit de onderneming heeft
                    gehaald voor privégebruik.<br/>
                    Privé-stortingen: Dit zijn bedragen die de eigenaar vanuit privé in de onderneming heeft gestort.
                </i>
                <div class="space10"></div>

                Bijvoorbeeld, stel dat het eigen vermogen aan het begin van het jaar € 50.000 was, aan het einde van het
                jaar € 70.000, er zijn € 15.000 aan privé-opnamen geweest en €5.000 aan privé-stortingen, dan bereken je
                de winst als volgt:
                <div class="space10"></div>
                Winst = (€ 70.000 - € 50.000) + € 10.000 - € 5.000 = € 20.000 + € 15.000 - € 5.000 = € 30.000
                <div class="space10"></div>

                <b>Conclusie</b><br/>
                Beide methodes leiden uiteindelijk tot dezelfde winstberekening, mits correct toegepast. De eerste
                methode is directer en makkelijker te begrijpen, terwijl de tweede methode meer inzicht geeft in hoe het
                eigen vermogen van de onderneming is veranderd over de tijd.
            </div>
        </div>
    </div>

</div>

